var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("loading", {
        attrs: { active: _vm.isLoading, "enforce-focus": false },
        on: {
          "update:active": function ($event) {
            _vm.isLoading = $event
          },
        },
      }),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            id: _vm.modal_id,
            title: "仕入",
            size: "xl",
            "header-bg-variant": "dark",
            "header-text-variant": "light",
            "body-bg-variant": "light",
            "hide-footer": "",
            centered: "",
          },
          on: { hide: _vm.closeModal },
        },
        [
          _c(
            "div",
            {
              staticClass: "main_modal_div",
              staticStyle: { "min-height": "500px" },
            },
            [
              _c(
                "div",
                {
                  staticClass: "form-inline",
                  staticStyle: { "margin-bottom": "5px" },
                },
                [
                  _c("label", {}, [_vm._v("発注日 ")]),
                  _vm._v(" "),
                  _c("v-date-picker", {
                    staticClass: "date_picker",
                    attrs: { "is-required": "" },
                    on: { input: _vm.onDateChange },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ inputValue, inputEvents }) {
                          return [
                            _c(
                              "b-input",
                              _vm._g(
                                { attrs: { value: inputValue, readonly: "" } },
                                inputEvents
                              )
                            ),
                          ]
                        },
                      },
                    ]),
                    model: {
                      value: _vm.date1,
                      callback: function ($$v) {
                        _vm.date1 = $$v
                      },
                      expression: "date1",
                    },
                  }),
                  _vm._v("\n         - \n        "),
                  _c("v-date-picker", {
                    staticClass: "date_picker",
                    attrs: { "is-required": "" },
                    on: { input: _vm.onDateChange },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ inputValue, inputEvents }) {
                          return [
                            _c(
                              "b-input",
                              _vm._g(
                                { attrs: { value: inputValue, readonly: "" } },
                                inputEvents
                              )
                            ),
                          ]
                        },
                      },
                    ]),
                    model: {
                      value: _vm.date2,
                      callback: function ($$v) {
                        _vm.date2 = $$v
                      },
                      expression: "date2",
                    },
                  }),
                  _vm._v("\n          \n        "),
                  _c(
                    "b-form-checkbox",
                    {
                      directives: [
                        {
                          name: "b-tooltip",
                          rawName: "v-b-tooltip.hover.bottom.v-info",
                          value: _vm.tooltip_matome,
                          expression: "tooltip_matome",
                          modifiers: {
                            hover: true,
                            bottom: true,
                            "v-info": true,
                          },
                        },
                      ],
                      attrs: { id: "checkbox-flg1", name: "checkbox-flg1" },
                      on: { change: _vm.getHattyuList },
                      model: {
                        value: _vm.item_sum_flg,
                        callback: function ($$v) {
                          _vm.item_sum_flg = $$v
                        },
                        expression: "item_sum_flg",
                      },
                    },
                    [_vm._v("\n          まとめて表示\n        ")]
                  ),
                  _vm._v("\n          \n        "),
                  !_vm.hattyu_load
                    ? _c(
                        "b-button",
                        {
                          staticStyle: { width: "120px !important" },
                          attrs: { variant: "success" },
                          on: { click: _vm.printHattyu },
                        },
                        [
                          _c("b-icon", { attrs: { icon: "printer" } }),
                          _vm._v(" 発注書\n        "),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.hattyu_load
                    ? _c(
                        "b-button",
                        {
                          staticStyle: { width: "120px !important" },
                          attrs: { variant: "success", disabled: "" },
                        },
                        [
                          _c("b-spinner", { attrs: { small: "" } }),
                          _vm._v("\n          Loading...\n        "),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", [
                _c(
                  "div",
                  { staticStyle: { width: "1200px" } },
                  [
                    _c("b-table-filter-pager", {
                      attrs: {
                        maxHeight: _vm.maxHeight,
                        filter_list: _vm.filter_list,
                        filter_val: _vm.filter_val,
                        filter_val_ex: _vm.filter_val_ex,
                        data_list_field: _vm.data_list_field,
                        data_list: _vm.data_list,
                        data_count: _vm.data_count,
                        busy: _vm.busy,
                        currentPage: _vm.current_page,
                        filter_enable: true,
                        nav_flg: true,
                        edit_disabled: _vm.pms_hattyu < 2,
                      },
                      on: {
                        on_sort: _vm.onSort,
                        on_page_change: _vm.onPageChange,
                        on_edit: _vm.onEdit,
                        on_hattyu_chk: _vm.onHattyuChk,
                        on_add: _vm.onEdit,
                        on_kensyu_chk: _vm.onKensyuChk,
                        on_filter_ex: _vm.onFilterEx,
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "form-inline",
                  staticStyle: { width: "1200px", "margin-top": "-45px" },
                },
                [
                  _c("label", { staticStyle: { "margin-left": "990px" } }, [
                    _vm._v("合計"),
                  ]),
                  _vm._v(" "),
                  _c("b-input", {
                    staticStyle: { width: "140px", "text-align": "right" },
                    attrs: { type: "text", disabled: "" },
                    model: {
                      value: _vm.hattyu_tanka_total,
                      callback: function ($$v) {
                        _vm.hattyu_tanka_total = $$v
                      },
                      expression: "hattyu_tanka_total",
                    },
                  }),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "b-modal",
            {
              attrs: {
                id: "modal-hattyu",
                title: _vm.title,
                "header-bg-variant": "dark",
                "header-text-variant": "light",
                "body-bg-variant": "light",
                "hide-footer": "",
                centered: "",
              },
            },
            [
              _c("div", { staticClass: "modal_div" }, [
                _c(
                  "div",
                  { staticClass: "form-inline" },
                  [
                    _c("label", [_vm._v("発注日")]),
                    _vm._v(" "),
                    _c("v-date-picker", {
                      staticClass: "date_picker",
                      attrs: { "is-required": "" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function ({ inputValue, inputEvents }) {
                            return [
                              _c(
                                "b-input",
                                _vm._g(
                                  {
                                    attrs: { value: inputValue, readonly: "" },
                                  },
                                  inputEvents
                                )
                              ),
                            ]
                          },
                        },
                      ]),
                      model: {
                        value: _vm.hattyu.hattyu_on,
                        callback: function ($$v) {
                          _vm.$set(_vm.hattyu, "hattyu_on", $$v)
                        },
                        expression: "hattyu.hattyu_on",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-inline" },
                  [
                    _c("label", [_vm._v("伝票番号")]),
                    _vm._v(" "),
                    _c("b-input", {
                      staticStyle: { width: "200px" },
                      attrs: { type: "text", readonly: "" },
                      model: {
                        value: _vm.hattyu.m_code_ex,
                        callback: function ($$v) {
                          _vm.$set(_vm.hattyu, "m_code_ex", $$v)
                        },
                        expression: "hattyu.m_code_ex",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-inline" },
                  [
                    _c("SelectItem", { on: { on_select: _vm.onItemSelect } }),
                    _vm._v(" "),
                    _c("label", [_vm._v("商品")]),
                    _vm._v(" "),
                    _vm.hattyu.m_code_ex != ""
                      ? _c(
                          "span",
                          [
                            _c("b-input", {
                              staticStyle: { width: "350px" },
                              attrs: { type: "text", readonly: "" },
                              model: {
                                value: _vm.hattyu.item_name,
                                callback: function ($$v) {
                                  _vm.$set(_vm.hattyu, "item_name", $$v)
                                },
                                expression: "hattyu.item_name",
                              },
                            }),
                            _vm._v(" "),
                            !_vm.item_loading
                              ? _c(
                                  "b-button",
                                  {
                                    staticClass: "icon_btn",
                                    attrs: { variant: "info", disabled: "" },
                                  },
                                  [
                                    _c("b-icon", {
                                      attrs: {
                                        icon: "search",
                                        "aria-hidden": "true",
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.item_loading
                              ? _c(
                                  "b-button",
                                  {
                                    staticClass: "icon_btn",
                                    attrs: { variant: "info", disabled: "" },
                                  },
                                  [
                                    _c("span", {
                                      staticClass:
                                        "spinner-border spinner-border-sm",
                                      attrs: {
                                        role: "status",
                                        "aria-hidden": "true",
                                      },
                                    }),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        )
                      : _c(
                          "span",
                          [
                            _c("b-input", {
                              staticStyle: {
                                width: "350px",
                                "background-color": "white",
                              },
                              attrs: { type: "text", readonly: "" },
                              on: { click: _vm.selectItemModalShow },
                              model: {
                                value: _vm.hattyu.item_name,
                                callback: function ($$v) {
                                  _vm.$set(_vm.hattyu, "item_name", $$v)
                                },
                                expression: "hattyu.item_name",
                              },
                            }),
                            _vm._v(" "),
                            !_vm.item_loading
                              ? _c(
                                  "b-button",
                                  {
                                    staticClass: "icon_btn",
                                    attrs: { variant: "info" },
                                    on: { click: _vm.selectItemModalShow },
                                  },
                                  [
                                    _c("b-icon", {
                                      attrs: {
                                        icon: "search",
                                        "aria-hidden": "true",
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.item_loading
                              ? _c(
                                  "b-button",
                                  {
                                    staticClass: "icon_btn",
                                    attrs: { variant: "info", disabled: "" },
                                  },
                                  [
                                    _c("span", {
                                      staticClass:
                                        "spinner-border spinner-border-sm",
                                      attrs: {
                                        role: "status",
                                        "aria-hidden": "true",
                                      },
                                    }),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-inline" },
                  [
                    _c("label", [_vm._v("数量")]),
                    _vm._v(" "),
                    _c("b-input", {
                      attrs: {
                        type: "number",
                        readonly: _vm.hattyu.m_code_ex != "",
                      },
                      model: {
                        value: _vm.hattyu.quantity,
                        callback: function ($$v) {
                          _vm.$set(_vm.hattyu, "quantity", $$v)
                        },
                        expression: "hattyu.quantity",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "modal-footer" },
                [
                  _c(
                    "b-button",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.$bvModal.hide("modal-hattyu")
                        },
                      },
                    },
                    [
                      _c("b-icon", { attrs: { icon: "x" } }),
                      _vm._v("取消\n        "),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      attrs: {
                        variant: "danger",
                        disabled:
                          _vm.hattyu.delete_disabled || _vm.hattyu.id == null,
                      },
                      on: { click: _vm.onDelete },
                    },
                    [
                      _c("b-icon", { attrs: { icon: "trash" } }),
                      _vm._v(" 削除\n        "),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "primary" },
                      on: { click: _vm.SaveHattyu },
                    },
                    [
                      _c("b-icon", { attrs: { icon: "save" } }),
                      _vm._v(" 保存\n        "),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }